import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ReactSVG from 'react-svg'
import {css} from 'glamor';
import * as globals from '../Globals/Globals'
import ItemTypes from '../ItemTypes'
import ErrorBoundary from 'react-error-boundary';
import {
	DragSourceMonitor,
  useDrag,
} from 'react-dnd'
import LaytoutDraggable from '../Layout/LayoutDraggable'
import {ATTRIBUTE_DRAG, ATTIBUTE_DEFAULT} from '../Attributes/Constants'
import composeRefs from '@seznam/compose-react-refs'
const styles = css({
    ' svg': {
      height: 25,
      width: 165
    },
  })

interface AttributeProps {
    content: string;
    id: string;
}


const Attributes: React.FC<AttributeProps> = ({ content, id }) => {

  

  
      const [, drag] = useDrag({
        item: { type: ItemTypes.Attributes, content: content, id:id},
        begin(monitor: DragSourceMonitor){
            
                var ele = document.getElementsByClassName('dropX') as HTMLCollectionOf<HTMLElement>;
                for (var i = 0; i < ele.length; i++ ) {
                    ele[i].style.backgroundColor = ATTRIBUTE_DRAG
                }
                var ele = document.getElementsByClassName('dropY') as HTMLCollectionOf<HTMLElement>;
                for (var i = 0; i < ele.length; i++ ) {
                    ele[i].style.backgroundColor = ATTRIBUTE_DRAG
                }
                var ele = document.getElementsByClassName('dropZ') as HTMLCollectionOf<HTMLElement>;
                for (var i = 0; i < ele.length; i++ ) {
                    ele[i].style.backgroundColor = ATTRIBUTE_DRAG
                }
                return { type: ItemTypes.Attributes, content: content, id:id}
        },
        end(item, monitor: DragSourceMonitor){

         

              if (!monitor.didDrop()) {
               
                var ele = document.getElementsByClassName('dropX') as HTMLCollectionOf<HTMLElement>;
                for (var i = 0; i < ele.length; i++ ) {
                    ele[i].style.backgroundColor = ATTIBUTE_DEFAULT
                }
                var ele = document.getElementsByClassName('dropY') as HTMLCollectionOf<HTMLElement>;
                for (var i = 0; i < ele.length; i++ ) {
                    ele[i].style.backgroundColor = ATTIBUTE_DEFAULT
                }
                var ele = document.getElementsByClassName('dropZ') as HTMLCollectionOf<HTMLElement>;
                for (var i = 0; i < ele.length; i++ ) {
                    ele[i].style.backgroundColor = ATTIBUTE_DEFAULT
                }
                return;
              }
             
            const dropTarget = monitor.getDropResult(); 
           
            if(dropTarget)
            {
             
              var ele = document.getElementsByClassName('dropX') as HTMLCollectionOf<HTMLElement>;
              for (var i = 0; i < ele.length; i++ ) {
                  ele[i].style.backgroundColor = ATTIBUTE_DEFAULT
              }
              var ele = document.getElementsByClassName('dropY') as HTMLCollectionOf<HTMLElement>;
              for (var i = 0; i < ele.length; i++ ) {
                  ele[i].style.backgroundColor = ATTIBUTE_DEFAULT
              }
              var ele = document.getElementsByClassName('dropZ') as HTMLCollectionOf<HTMLElement>;
              for (var i = 0; i < ele.length; i++ ) {
                  ele[i].style.backgroundColor = ATTIBUTE_DEFAULT
              }
              
              if(dropTarget.type =='yAxis' || dropTarget.type =='zAxis'|| dropTarget.type =='xAxis' )
              {
                
              }
              else
              {
                var allgraph = []
                globals.graphElements.graphs.push(dropTarget);
           
                for (var graph of globals.graphElements.graphs) {
                    console.log('graph.id',graph.id)
                    var element = document.getElementById(graph.id) as HTMLElement;
                    console.log('coordinates', graph.clientOffsetX,graph.clientOffsetY);
                    var graph_parent = globals.randomIntFromInterval(100,999).toString()
                    allgraph.push(<LaytoutDraggable x={graph.clientOffsetX} y={graph.clientOffsetY} xaxis={graph.content} yaxis="Count" id={id} 
                    className={'graph_parent_'+graph_parent}
                    childClassName={'child_'+graph_parent}
                    topGraphTarget={element.offsetTop} bottomGraphTarget={element.offsetHeight}
                    leftGraphTarget={element.offsetLeft} rightraphTarget={element.offsetWidth} datatype={graph.datatype}>
                    </LaytoutDraggable>)
                   
                }
              
           
                ReactDOM.render(allgraph
                  ,document.getElementById('graph'))
              }
            
              
            }
        }

      })
       
    return (
      <ErrorBoundary>
      <div id={id} ref={drag} >
       
        <ReactSVG  src='svg/attributes.svg'
        title= {globals.dataset.attribute_description[content]}
        beforeInjection={svg => {
        svg.id = globals.randomIntFromInterval(100,999).toString();
        const textElement = Array.from(svg.querySelectorAll('text'));
        textElement.forEach(textelement => {
          if(textelement.id == "attribute-text")
          {
            textelement.textContent = content;
            
          }
        
        });
      
      }} id={id} {...styles}>
      </ReactSVG>
     
     

      

      </div>
      </ErrorBoundary>
    )
}

export default Attributes;
